import { Injectable } from "@angular/core";
import {
    HttpClient,
    HttpHeaders,
    HttpErrorResponse,
    HttpStatusCode,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { SecurityService } from "./security.service";
import { ToastrService } from "ngx-toastr";
//service
import { Router } from "@angular/router";
import { baseUrl } from "../../../environments/environment";
import { StorageService } from "./storage.service";
import { RealtimeService } from "./realtime.service";
import { AUTHORIZED_TOKEN, HttpMethod, REFRESH_TOKEN, SESSION_EXPIRE_TIME, TOKEN_EXPIRATION_MS } from "../enum/common-enum";
// declare var require;
// const Swal = require('sweetalert2');

// Implementing a Retry-Circuit breaker policy
// is pending to do for the SPA app
@Injectable({
    providedIn: "root",
})
export class DataService {
    private worker!: Worker;
    constructor(
        private http: HttpClient,
        private securityService: SecurityService,
        private router: Router,
        private toaster: ToastrService,
        private storageservice: StorageService,
        private realtimeService : RealtimeService
    ) {
        if (typeof Worker !== 'undefined') {
            this.worker = new Worker(new URL('./../web-worker/background.worker', import.meta.url));
    
            this.worker.onmessage = ({ data }) => {
            console.log('Background API');
            this.setNewTokenAndExpiryTime(data)
            this.callRefreshTokenApiCallCount = 0;
            };
          }
    }

    setNewTokenAndExpiryTime(res){
        if (res?.isSucceeded) {
            this.storageservice?.store(AUTHORIZED_TOKEN, res?.response?.accessToken);
            this.storageservice?.store(REFRESH_TOKEN,res?.response?.refreshToken);
            const tokenExpireTime = this.storageservice?.getCurrentDateTimeInMilliseconds() + TOKEN_EXPIRATION_MS;
            this.storageservice?.store(SESSION_EXPIRE_TIME, tokenExpireTime);
            } else {
                this.router.navigateByUrl("auth/login");
            }
    }

  
    get(
        url: string,
        isAuthTokenRequired: boolean = true,
        params?: any,
        isEnableLoader: boolean = true,
        responceTye?
    ): Observable<Response> {
        return this.doGet(
            baseUrl + url,
            isAuthTokenRequired,
            params,
            isEnableLoader,
            responceTye
        );
    }

    post(
        url: string,
        data: any,
        isAuthTokenRequired: boolean = true,
        params?: any,
        isEnableLoader: boolean = true,
        idempotencyKey?:string 
    ): Observable<Response> {
        return this.doPost(
            baseUrl + url,
            data,
            isAuthTokenRequired,
            params,
            isEnableLoader,
            idempotencyKey
        );
    }

    postWithId(
        url: string,
        data: any,
        isAuthTokenRequired: boolean = true,
        params?: any,
        isEnableLoader: boolean = true
    ): Observable<Response> {
        return this.doPost(
            baseUrl + url,
            data,
            isAuthTokenRequired,
            params,
            isEnableLoader
        );
    }

    putWithId(
        url: string,
        data: any,
        isAuthTokenRequired: boolean = true,
        params?: any,
        isEnableLoader: boolean = true
    ): Observable<Response> {
        return this.doPut(
            baseUrl + url,
            data,
            isAuthTokenRequired,
            params,
            isEnableLoader
        );
    }

    upload(
        url: string,
        data: any,
        isAuthTokenRequired: boolean = true,
        params?: any,
        isEnableLoader: boolean = false
    ): Observable<any> {
        return this.doUpload(
            baseUrl + url,
            data,
            isAuthTokenRequired,
            params,
            isEnableLoader
        );
    }

    delete(
        url: string,
        isAuthTokenRequired: boolean = true,
        params?: any,
        isEnableLoader: boolean = false
    ): Observable<Response> {
        return this.doDelete(
            baseUrl + url,
            isAuthTokenRequired,
            params,
            isEnableLoader
        );
    }

    patch(url: string, data: any, isAuthTokenRequired: boolean = true, params?: any, isEnableLoader: boolean = true): Observable<Response> {
        return this.doPatch(baseUrl + url, data, isAuthTokenRequired, params, isEnableLoader);
    }

    private doUpload(
        url: string,
        data: any,
        isAuthTokenRequired: boolean = true,
        params?: any,
        isEnableLoader: boolean = false
    ): Observable<Response> {
        let httpOptions = {
            headers: new HttpHeaders(),
        };

        httpOptions = this.securityService.setHeaders(
            isAuthTokenRequired,
            isEnableLoader,
            params
        );
        this.setConnectionId(httpOptions,url);
        this.checkTokenExpireTimeAndCallRerfreshApi(httpOptions);
        return this.http.post(url, data, httpOptions).pipe(
            tap((res: Response) => {
                return res;
            }),
            catchError((err: HttpErrorResponse) => this.handleError(err))
        );
    }

    private doGet(
        url: string,
        isAuthTokenRequired: boolean = true,
        params?: any,
        isEnableLoader: boolean = true,
        responceTye?
    ): Observable<Response> {
        let httpOptions = {
            headers: new HttpHeaders(),
        };

        httpOptions = this.securityService.setHeaders(
            isAuthTokenRequired,
            false,
            null,
            null,
            responceTye
        );
        this.setConnectionId(httpOptions,url);
        this.checkTokenExpireTimeAndCallRerfreshApi(httpOptions);
        if (params != undefined) {
            // Convert the data object to query parameters
            if(Array.isArray(params)){
                let isFirstParam = true;
                let queryString = "";
                params.forEach(a=>{
                const queryParams = Object.entries(a)
                .filter(([key, value]) => value !== undefined && value !== null)
                .map(([key, value]: any) => {
                    if (isFirstParam) {
                        queryString += `?${key}=${value}`;
                        isFirstParam = false;
                    } else {
                        queryString += `&${key}=${value}`;
                    }
                })
            })
            url = url + queryString;
            }else{
                const queryParams = Object.entries(params)
                .filter(([key, value]) => value !== undefined && value !== null)
                .map(([key, value]: any) => {
                    if (
                        key === "dateRange" ||
                        key === "startTimeRange" || 
                        key === "endTimeRange" ||  key === "timeRange"
                    ) {
                        // Handle dateRange separately
                        return Object.entries(value)
                            .map(([dateKey, dateValue]) =>
                                dateValue
                                    ? `${key}.${dateKey}=${dateValue}`
                                    : null
                            )
                            .join("&");
                    } else if (key === "pagination" || key === "sort") {
                        // Handle pagination and sort objects by stringifying them
                        if (params.pagination && params.sort) {
                            const nestedParams = Object.entries(value)
                                .map(
                                    ([nestedKey, nestedValue]) =>
                                        `${key}.${nestedKey}=${nestedValue}`
                                )
                                .join("&");
                            return nestedParams;
                        }
                    } else if (params[key]?.length){
                        if(key == 'appointmentStatusIds'){
                            const queryString = params[key]?.map(id => `${key}=${id}`).join('&');
                            return queryString;
                        }
                        }

                    return `${key}=${encodeURIComponent(value)}`;
                })
                .join("&");
                if (queryParams) {
                    url += `?${queryParams}`;
                }
            }

            // Append the query parameters to the URL

        }
        return this.http.get(url, httpOptions).pipe(
            tap((res: Response) => {
                return res;
            }),
            catchError((err) => this.handleError(err))
        );
    }

    private doPost(
        url: string,
        data: any,
        isAuthTokenRequired: boolean = true,
        params?: any,
        isEnableLoader: boolean = true,
        idempotencyKey?:string
    ): Observable<Response> {
        let httpOptions = {
            headers: new HttpHeaders(),
        };

        httpOptions = this.securityService.setHeaders(
            isAuthTokenRequired,
            false,
            params,
            idempotencyKey
        );
        this.setConnectionId(httpOptions,url);
        this.checkTokenExpireTimeAndCallRerfreshApi(httpOptions);
        return this.http.post(url, data, httpOptions).pipe(
            tap((res: any) => {
                return res;
            }),
            catchError((err) => this.handleError(err))
        );
    }

    private doDelete(
        url: string,
        isAuthTokenRequired: boolean = true,
        params?: any,
        isEnableLoader: boolean = true
    ): Observable<Response> {
        let httpOptions = {
            headers: new HttpHeaders(),
        };

        httpOptions = this.securityService.setHeaders(
            isAuthTokenRequired,
            false,
            params
        );
        this.setConnectionId(httpOptions,url);
        this.checkTokenExpireTimeAndCallRerfreshApi(httpOptions);
        return this.http.delete(url, httpOptions).pipe(
            tap((res: Response) => {
                return res;
            }),
            catchError((err) => this.handleError(err))
        );
    }

    private doPut(
        url: string,
        data: any,
        isAuthTokenRequired: boolean = true,
        params?: any,
        isEnableLoader: boolean = true
    ): Observable<Response> {
        let httpOptions = {
            headers: new HttpHeaders(),
        };

        httpOptions = this.securityService.setHeaders(
            isAuthTokenRequired,
            false,
            params
        );
        this.setConnectionId(httpOptions,url);
        this.checkTokenExpireTimeAndCallRerfreshApi(httpOptions);
        return this.http.put(url, data, httpOptions).pipe(
            tap((res: Response) => {
                return res;
            }),
            catchError((err) => this.handleError(err))
        );
    }

    private doPatch(
        url: string,
        data: any,
        isAuthTokenRequired: boolean = true,
        params?: any,
        isEnableLoader: boolean = true,
        idempotencyKey?:string
        ): Observable<Response> {

        let httpOptions = {
            headers: new HttpHeaders()
        };

        httpOptions = this.securityService.setHeaders(
            isAuthTokenRequired,
            false,
            params,
            idempotencyKey
        );
        this.setConnectionId(httpOptions,url);
        this.checkTokenExpireTimeAndCallRerfreshApi(httpOptions);
        return this.http.patch(url, data, httpOptions)
            .pipe(
                tap((res: any) => {
                    return res;
                }),
                catchError(err => this.handleError(err))
            );
    }

    callRefreshTokenApiCallCount: number = 0;
    isRefreshTokenUpdate: boolean;

    private handleError(error: any) {
        if (error.status === HttpStatusCode.Unauthorized) {
            this.router.navigateByUrl("auth/login");
        } else if (error.error instanceof ErrorEvent) {
            if (error.error != undefined) {
                this.toaster.error(error.error);
            }
            if (error.error.errors.length > 0) {
                this.toaster.error(error.error.errors[0]);
            }
            return throwError(error || "server error");
        } else if (error.status === 400) {
            if (error.error.Message != undefined) {
                this.toaster.error(error.error.Message);
            }
        }
    }

    setConnectionId(httpOptions:{headers: HttpHeaders;} , url){
        if( this.realtimeService.cieloapi_connectionId) httpOptions.headers = httpOptions?.headers?.set('X-SignalR-ConnectionId', this.realtimeService.cieloapi_connectionId);
    }


    checkTokenExpireTimeAndCallRerfreshApi(httpOptions){
        const currentDateAndtime =  this.storageservice?.getCurrentDateTimeInMilliseconds();
        const tokenExpireTime = this.storageservice?.retrieve(SESSION_EXPIRE_TIME);
        if(tokenExpireTime  &&  currentDateAndtime > tokenExpireTime)  {
            this.callRefreshTokenApi(httpOptions);
        } 
    }

      sendApiRequest(url:string,requestBody:{},method:HttpMethod,token:string): void {
        if (this.worker) {
          this.worker.postMessage({
            apiUrl: baseUrl + url,
            method: method, // Change to 'GET' for a GET request
            token: token,
            body: requestBody
          });
        }
      }
    

    callRefreshTokenApi(httpOptions){
        if (this.callRefreshTokenApiCallCount == 0 ) {
            const token = this.storageservice?.retrieve(AUTHORIZED_TOKEN);
            let url = "clo-api/identity/auth/refresh-token";
            const requestModel = {
                refreshToken: this.storageservice?.retrieve(REFRESH_TOKEN),
            };

            this.sendApiRequest(url ,requestModel ,HttpMethod.POST,token)

        this.callRefreshTokenApiCallCount++
        }
    }

    refreshApi(url,data,httpOptions): Observable<Response>{
        return this.http.post(url, data, httpOptions)
            .pipe(
                tap((res: any) => {
                    return res;
                }),
                catchError(err => this.handleError(err))
            );
        }
}